import _ from 'lodash';
import { pushNotification, updatePushNotification, deleteNotification } from '../../apis/backend';
import { ERROR_PUSH_NOTIFICATION, ERROR_WRONG_INFORMATIONS, ERROR_SCHEDULED_DATE, ERROR_DELETE_NOTIFICATION, SUCCESS_UPDATE_TEXT, SUCCESS_DELETE_TEXT } from '../../constants';
import { isStringNotNull, combineDateAndTime } from '../../utils/tools';
import { NOTIF_TABLE_HEAD } from '../../constants/table';
import { showNotification } from '../../components/Notification/Notification.view'
import moment from 'moment';
export const handleClick = (setStateObj, createPushNotif = false, isSchedule = false, e = {}) => {
  setStateObj({
    modalOpen: true,
    createPushNotif,
    pushNotif: e,
    isSchedule
  });
}


export const handleClose = setStateObj => {
  setStateObj({
    modalOpen: false,
    pushNotif: {},
    isLoadingModal: false,
    createPushNotif: false,
    isSchedule: false
  });
}



export const handleSendNotification = async (stateObj, setStateObj, selectedDate, selectedTime, isAdminOfOneShop, openErrorModal, isAllShops) => {
  if (stateObj.isSchedule && moment().isSameOrAfter(combineDateAndTime(selectedDate, selectedTime))) {
    openErrorModal(ERROR_SCHEDULED_DATE);
    return
  }

  if (isStringNotNull(stateObj?.pushNotif?.message) && isStringNotNull(stateObj?.pushNotif?.title)) {
    try {
      setStateObj({ isLoadingModal: true });
      stateObj?.pushNotif?.id ?
        await updatePushNotification({
          title: stateObj?.pushNotif?.title,
          message: stateObj?.pushNotif?.message,
          id: stateObj?.pushNotif?.id,
          scheduledDate: combineDateAndTime(selectedDate, selectedTime),
          toAllUsers: (isAllShops || isAdminOfOneShop)
        }) :
        await pushNotification({
          title: stateObj?.pushNotif?.title,
          message: stateObj?.pushNotif?.message,
          ...(stateObj.isSchedule
            ? { scheduledDate: combineDateAndTime(selectedDate, selectedTime) }
            : {}),
          toAllUsers: (isAllShops || isAdminOfOneShop)
        })
      handleClose(setStateObj)
      showNotification(
        'light',
        'ltr',
        'primary',
        SUCCESS_UPDATE_TEXT,
        `La notification a bien été  ${stateObj?.pushNotif?.id ? 'modifiée' : 'ajoutée'}`
      );
    } catch (error) {
      openErrorModal(ERROR_PUSH_NOTIFICATION);
      setStateObj({ isLoadingModal: false });
    }
  } else {
    openErrorModal(ERROR_WRONG_INFORMATIONS);
    setStateObj({ isLoadingModal: false });
  }
};

export const handleChange = async (event, setStateObj) => {
  setStateObj({ [event.target.id]: event.target.checked });
};
export const getAllShopsPushNotification = (pushNotifications) => {
  let notificationsById = {};
  _.map(pushNotifications, pushNotif => {
    _.forEach(pushNotif, (elm) => {
      if (elm.toAllUsers) {
        const { id, nbUsers = 0, ...rest } = elm;
        if (!notificationsById[id]) {
          notificationsById[id] = { ...rest, id, nbUsers: 0 };
        }
        notificationsById[id].nbUsers += nbUsers;
      }
    });
  })

  return notificationsById;
}
export const definePushNotifTableHeads = (isAllShops) => {
  if (!isAllShops) {
    return NOTIF_TABLE_HEAD;
  }
  return NOTIF_TABLE_HEAD.filter(item => item.id !== 'cible');
}
export const deleteScheduledNotification = async (stateObj, setStateObj, openErrorModal) => {
  const { id, toAllUsers } = stateObj?.pushNotif;
  try {
    setStateObj({ isLoadingModal: true });
    await deleteNotification(id, toAllUsers);
    handleClose(setStateObj)
    showNotification(
      'light',
      'ltr',
      'primary',
      SUCCESS_DELETE_TEXT,
      `La notification programmée a bien été supprimée`
    );
  } catch (e) {
    openErrorModal(ERROR_DELETE_NOTIFICATION);
    setStateObj({ isLoadingModal: false });
  }
};
export const handleRowClick = (pushNotif, setStateObj, isAllShops, nbShops) => {
  const isScheduled = pushNotif.scheduledDate;
  const notSent = pushNotif.status !== 'sent';
  const shopCondition =
    (isAllShops && pushNotif.toAllUsers) || (!isAllShops && !pushNotif.toAllUsers) || nbShops === 1;
  if (isScheduled && notSent && shopCondition) {
    handleClick(setStateObj, false, true, pushNotif);
  }
}

